import { create, StoreApi, UseBoundStore } from 'zustand';

import { SortingState } from '@tanstack/react-table';

import FilterValueArray from 'models/filterValues/FilterValueArray';

import { FilterState } from './types';

export type PreferredProvidersFilterState = FilterState<FilterValueArray>;

type PreferredProvidersActions = {
  setFilters: (filters: PreferredProvidersFilterState) => void;
  setSort: (sort: SortingState) => void;
  setSearch: (search: string) => void;
  removeFilter: (filterKey: string, id: string) => void;
  setExpanded: (expanded: boolean) => void;
};

type PreferredProvidersState = {
  filters: PreferredProvidersFilterState;
  sort: SortingState;
  search: string;
  expanded: boolean;
  actions: PreferredProvidersActions;
};

const createPreferredProvidersStore = (): [
  useStore: UseBoundStore<StoreApi<PreferredProvidersState>>,
  useActions: () => PreferredProvidersActions,
] => {
  const useStore = create<PreferredProvidersState>((set) => ({
    filters: {},
    sort: [{ id: 'locationName', desc: false }],
    search: '',
    expanded: false,
    actions: {
      setExpanded: (expanded) => set({ expanded }),
      setFilters: (filters) => set({ filters }),
      setSort: (sort) => set({ sort }),
      setSearch: (search) => set({ search }),
      removeFilter: (filterKey, id) =>
        set((state) => ({
          filters: {
            ...state.filters,
            ...(state.filters[filterKey] ? { [filterKey]: state.filters[filterKey].removeFilter(id) } : {}),
          },
        })),
    },
  }));

  const useActions = () => useStore((state) => state.actions);

  return [useStore, useActions];
};

export const [usePreferredProvidersStore, usePreferredProvidersActions] = createPreferredProvidersStore();
